import { Description } from '../Description'

import { blockTitleStyles, blockWapperStyles } from './styles'
import { DevelopingSolutionFlowProps } from './types'

export function DevelopingSolutionFlow({
  blocks,
}: DevelopingSolutionFlowProps) {
  return (
    <>
      {blocks.map(block => (
        <Description
          titleAs="h4"
          titleAdditionalStyles={blockTitleStyles}
          wrapperAdditionalStyles={blockWapperStyles}
          key={block.title}
          {...block}
        />
      ))}
    </>
  )
}
